import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {PressureConfig, PressureConfigJson} from './pressure-config';

export type MaxZoomConfigJson =  {
  time: number;
  pressure: PressureConfigJson;
  zoomOutMaxFactor: number;
};

export class MaxZoomConfig implements JsonConfigInterface<MaxZoomConfigJson> {

  public readonly pressure: PressureConfig = new PressureConfig();

  private _time: number = 0;
  private _zoomOutMaxFactor: number = 0;

  constructor(json?: MaxZoomConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get time(): number {
    return this._time;
  }

  public get zoomOutMaxFactor(): number {
    return this._zoomOutMaxFactor;
  }

  public deserializeJson(json: MaxZoomConfigJson): void {
    this._time = json.time;
    this.pressure.deserializeJson(json.pressure);
    this._zoomOutMaxFactor = json.zoomOutMaxFactor;
  }
}
